import { Component, Inject } from '@angular/core';
import { StateService } from "@uirouter/angular";
import { CVCompetenceGroupsService } from "../../core/cvcompetencegroups.dataservice";
import { MatDialog } from "@angular/material/dialog";
import { DetailsBase } from "../shared/details.base";

@Component({
    selector: "crew-cvcompetencegroup",
    template: require('../shared/details-view.html')
})
export class CVCompetenceGroup extends DetailsBase<Nema.Crew.Model.CVCompetenceGroup> {
    constructor(
        stateService: StateService,
        dialog: MatDialog,
        @Inject('cvcompetencegroup') cvcompetencegroup: Nema.Crew.Model.CVCompetenceGroup,
        @Inject('cvCompetenceGroupsService') cvcompetencegroupDataService: CVCompetenceGroupsService,
        @Inject('$log') $log: ng.ILogService) {

        super(stateService, dialog, cvcompetencegroup, cvcompetencegroupDataService, $log);
    }

    public entityName = "CV Competence Group";

    public editStateName = "app.settings.cvcompetencegroups.edit";

    public listStateName = "app.settings.cvcompetencegroups";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/cvcompetencegroups/cvcompetencegroup.component.ts